import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import React, {useState} from 'react';
import {
  UpdatePasswordForm,
  UpdatePasswordFormSubmission,
} from 'components/UpdatePasswordDialog/UpdatePasswordForm';
import {apiLOGIN, apiUpdatePassword} from 'constants/Api';
import CheckIcon from 'components/CheckIcon/CheckIcon';
import {Button} from '@material-ui/core';
import {ISupplierUserProfile} from 'constants/interfaces';

export function UpdatePasswordDialog(props: {
  user: ISupplierUserProfile;
  open: boolean;
  onClose: VoidFunction;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = (submission: UpdatePasswordFormSubmission) => {
    setIsLoading(true);
    apiUpdatePassword(submission.oldPassword, submission.newPassword)
      .then((response) => {
        if (!response.success) alert(response.message);
        else
          return apiLOGIN(props.user.email, submission.newPassword).then(() =>
            setIsSuccess(true),
          );
      })
      .catch((err) => {
        alert(
          'Failed to update password at the moment. Please try again later',
        );
        console.error('Error updating password', err);
      })
      .finally(() => setIsLoading(false));
  };

  const handleCancel = () => {
    setIsSuccess(false);
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      className="update-password-dialog"
    >
      <DialogTitle>Update Password</DialogTitle>
      <DialogContent>
        {isSuccess && <SuccessfullyUpdatedPassword onClose={handleCancel} />}
        {!isSuccess && (
          <UpdatePasswordForm
            isLoading={isLoading}
            submitButtonTitle={'Update'}
            onSubmit={handleSubmit}
            cancelButtonTitle={'Cancel'}
            onCancel={handleCancel}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}

function SuccessfullyUpdatedPassword(props: {onClose: VoidFunction}) {
  return (
    <div className="side-panel-success-container">
      <div className="mid-section">
        <div className="success-gif">
          <CheckIcon />
        </div>
        <div className="success-msg">Password updated successfully</div>
      </div>
      <div className="btn-container">
        <Button
          className="primary-btn"
          type="submit"
          variant="outlined"
          color="primary"
          onClick={props.onClose}
        >
          Close
        </Button>
      </div>
    </div>
  );
}
